import axios from "axios";

export const baseClient = () => {
  return axios.create();
};

export const authClient = () => {
  return axios.create({
    withCredentials: true,
  });
};

export const PRO =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "pro";

export const API = PRO
  ? "https://api.tipify.tips/api"
  : "http://localhost:4002/api";

export const SERVER_URL = PRO
  ? "https://api.tipify.tips"
  : "http://localhost:4002";

export const WEB_URL = PRO
  ? "https://app.tipify.tips"
  : "http://localhost:3001";

/** Tipify Me: web del tiper (historial, impacto, perfil). */
export const ME_URL = PRO
  ? "https://me.tipify.tips"
  : "http://localhost:5174";

/**
 * Versión del texto de consentimiento que se muestra en la pantalla de éxito
 * (success.email.privacyText / privacyModal). Subir cuando cambie el texto.
 */
export const CONSENT_VERSION = "2026-10";

export const BACKOFFICE_URL =
  /*PRO
	? "https://admin.tipify.tips"
	: */ "https://admin.tipify.tips";

export const GOOGLE_MAPS_API_KEY = "";
export const STRIPE_API_KEY = PRO
  ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PRO
  : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST;
